import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { LayoutModuleConfig } from '@portal-core/layout/models/layout-module-config';
import { LayoutModuleConfigService } from '@portal-core/layout/services/layout-module-config.service';

/**
 * Provides the layout module configuration. The standalone replacement for
 * `LayoutServicesModule.forRoot(config)` — call it in an application's bootstrap providers.
 * @param config The layout module configuration (event handler bindings).
 */
export function provideLayoutServices(config: LayoutModuleConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: LayoutModuleConfigService,
      useValue: config
    }
  ]);
}
